import React, {useEffect, useRef, useState} from 'react';
import {useStores} from "../../../../stores/Context";
import axios from "axios";
import ReactQuill, {Quill} from "react-quill";
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';
import BtnPrimary from "../../../../boiteAOutils/BtnPrimary";
import {observer} from "mobx-react";
import BtnTiertary from "../../../../boiteAOutils/BtnTiertary";
Quill.register('modules/imageResize', ImageResize);
const WidgetConsignesContentAdd = observer((props) => {

    const {widgetStore, consignesStore, bibliothequeImagesStore, sidebarWidgetStore} = useStores();
    const [tagSelected, setTagSelected] = useState('');
    const [value, setValue] = useState( '');
    const [listTags, setListTags] =useState([]);
    const [uploadError, setUploadError] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const quillRef = useRef(null);
    const directImageInputRef = useRef(null);


    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/getTagsByIdTotem/' + widgetStore.idTotem    ,
            { headers: {"Authorization" : `Bearer ${widgetStore.getCookie("current_apiToken")}`} }
        ).then((res) => {
            setListTags(res.data);
        })
    }, [])

    const handleBtnViewGestion = () => {
        consignesStore.handleViewGestion()
    }

    const handleBtnViewHome = () => {
        consignesStore.handleViewHome()
    }

    const handleBtnAdd = () => {

        axios.post(process.env.REACT_APP_API_URL + '/api/addConsigne', {
            content: value,
            tag: tagSelected,
            id_totem: widgetStore.idTotem
        }    ,
            { headers: {"Authorization" : `Bearer ${widgetStore.getCookie("current_apiToken")}`} }
        ).then((res) => {
            props.onClose();
            consignesStore.resetViews();
            bibliothequeImagesStore.handleCloseModuleImage();
        })
    }

    useEffect(() => {
        if (bibliothequeImagesStore.selectedImageModule){
            handleInsertPhoto(bibliothequeImagesStore.selectedImageModule);
            bibliothequeImagesStore.onResetImageModule();
        }
    }, [bibliothequeImagesStore.selectedImageModule]);



   const handleInsertPhoto = (imageUrl) => {
     if (quillRef.current) {
         const editor = quillRef.current.getEditor();
         const range = editor.getSelection();
         const imageSource = /^https?:\/\//i.test(imageUrl)
             ? imageUrl
             : `${process.env.REACT_APP_API_URL}/${String(imageUrl).replace(/^\/+/, '')}`;

         if (range) {
             editor.insertEmbed(range.index, 'image', imageSource);
         } else {
             editor.insertEmbed(0, 'image', imageSource);
         }
     }
   }

    const handleDirectImageUpload = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        setUploadError('');

        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
            setUploadError('Choisissez une image JPG, PNG, WEBP ou GIF.');
            return;
        }
        if (file.size === 0 || file.size > 10 * 1024 * 1024) {
            setUploadError('L’image doit peser entre 1 octet et 10 Mo.');
            return;
        }

        try {
            setIsUploading(true);
            const formData = new FormData();
            formData.append('file', file, file.name);
            formData.append('id_totem', widgetStore.idTotem);
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/bibliothequeImages/upload`,
                formData,
                {headers: {Authorization: `Bearer ${widgetStore.getCookie('current_apiToken')}`}},
            );
            handleInsertPhoto(response.data?.url);
        } catch (error) {
            const apiError = error.response?.data?.errors?.file?.[0]
                || error.response?.data?.errors?.id_totem?.[0]
                || error.response?.data?.message;
            setUploadError(apiError || 'L’image n’a pas pu être importée. Réessayez dans un instant.');
        } finally {
            setIsUploading(false);
        }
    };

    const modules = {
        toolbar: [
            ['image']
        ],
        clipboard: {
            matchVisual: false,
        },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize']
        }
    };

    const handleChangeContentEditor = (val) => {
        setValue(val)
    }

    return (
        <div className={"consigneModifyBody"}>
            <div className={"consigneModifyHeader"}>
                <h3 className={"consigneModifyTitleH3"}>Ajouter une nouvelle consigne</h3>
                <div onClick={() => {
                    consignesStore.resetViews();
                    bibliothequeImagesStore.handleCloseModuleImage();
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div className={"consigneModifyHeaderSeparateur"}></div>
            <div className={"consigneModifyBodyContent"}>

                <div className={"consigneModifyEditorTagContent"}>

                    <label className={"consigneModifyEditorTagContentLabel"}>Catégorie : </label>
                    <select className={"consigneModifyEditorTagContentInput"}
                            onChange={(e) => setTagSelected(e.target.value)}>
                        <option value={''} disabled selected>Selectionner parmi les catégories</option>
                        <option value={''}>--- Aucune catégorie ---</option>
                        {
                            listTags.map((data) => (
                                <option value={data.id} key={'T_' + data.id}>{data.nom}</option>
                            ))
                        }
                    </select>
                </div>
                <div className={"editorTagContentBtn"}>
                    <button type={"button"}
                            className={"editorTagParametresBtn"}
                            onClick={handleBtnViewGestion}>
                        Ajouter une catégorie dans les paramètres
                    </button>
                </div>

                <div className={"consigneModifyEditorContent"}>
                    <label className={"consigneEditorLabel"}>Message :</label>
                    <ReactQuill theme="snow"
                                ref={quillRef}
                                modules={modules}
                                value={value}
                                onChange={(val) => handleChangeContentEditor(val)}
                                placeholder={"Message de la consigne"}
                    />
                </div>
            </div>

            <div className={"consigneModifyBtnContent"}>
                <div className={"consigneImageActions"}>
                    <input
                        ref={directImageInputRef}
                        type="file"
                        accept="image/jpeg,image/png,image/webp,image/gif"
                        onChange={handleDirectImageUpload}
                        className={"consigneDirectImageInput"}
                        aria-label="Importer une image dans la consigne"
                    />
                    <BtnTiertary
                        onClick={() => directImageInputRef.current?.click()}
                        disabled={isUploading}
                        style={{width: "100%", justifyContent: "left", padding: "8px 16px"}}
                    >
                        {isUploading ? 'Import en cours…' : 'Importer une image'}
                    </BtnTiertary>
                    <BtnTiertary onClick={() => {
                        bibliothequeImagesStore.handleOpenModuleImage();
                        sidebarWidgetStore.handleOpenSidebarWidget();
                    }}
                                 style={{width: "100%", justifyContent: "left", padding: "8px 16px"}}>
                        <svg width="22" height="21" viewBox="0 0 22 21" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.83301 3.83203H20.1663V17.1654H1.83301V3.83203Z" stroke="#A8B0B3"
                                  strokeWidth="2"/>
                            <path d="M1.83301 16.3333L14.1247 8L20.1663 11.3333" stroke="#A8B0B3" strokeWidth="2"/>
                            <circle cx="6.00033" cy="8.0013" r="0.833333" stroke="#A8B0B3" strokeWidth="2"/>
                        </svg>
                        Mes images
                    </BtnTiertary>
                    <small className={"consigneImageHint"}>JPG, PNG, WEBP ou GIF · 10 Mo max · l’image est aussi ajoutée à Mes images.</small>
                    {uploadError && <p className={"consigneImageError"} role="alert">{uploadError}</p>}
                </div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center" ,width: "40%"}}>
                    <button type={"button"} className={"consigneBtnAnnuler"} onClick={handleBtnViewHome}>Annuler</button>
                    <BtnPrimary onClick={handleBtnAdd}>Ajouter</BtnPrimary>
                </div>
            </div>


        </div>
    );
});

export default WidgetConsignesContentAdd;
